export enum JensiatEnum {
  MARD = 0,
  ZAN = 1,
}
